define(
    'models/awards.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var AwardsModel = Loader.Backbone.Model.extend({

            defaults: {

            },

            initialize: function()
            {
                this.model = this.get('model');
            },

            getAwards: function(data, callback, silent)
            {
                var request = {
                    "board_id": this.model.get('forum').get('boardId'),
                    "sort": Helper.getParam('sort') || Config.modules.awards.board_award_sort
                };

                if (Helper.getParam('uid') > 0)
                    request.users_ids = Helper.getParam('uid');

                if (data.sort) request.sort = data.sort;
                if (data.users_ids) request.users_ids = data.users_ids;

                if (request.users_ids) {
                    request.sort = "user";
                }

                if (data.limit) {
                    request.limit = data.limit;
                    request.offset = data.offset || 0;
                }

                Sandbox.transport.send(Config.transport.channels.getAwards, request, function(data){
                    _.isFunction(callback) && callback(data);
                }, function(){},
                (silent != 'undefined' ? silent : true));
            },

            deleteAward: function(id, callback, errCallback)
            {
                Sandbox.transport.send(Config.transport.channels.deleteAward, {
                    "board_id": this.model.get('forum').get('boardId'),
                    "user_id": this.model.get('users').getMe().get('id'),
                    "id": id
                }, function(data){
                    _.isFunction(callback) && callback(data);
                }, function(data){
                    _.isFunction(errCallback) && errCallback(data);
                }, true);
            },

            sendAward: function(obj, callback, errCallback)
            {
                Sandbox.transport.send(Config.transport.channels.sendAward, {
                    "board_id": this.model.get('forum').get('boardId'),
                    "user_id": this.model.get('users').getMe().get('id'),
                    "from_id": this.model.get('users').getMe().get('id'),
                    "to_id": parseInt(Helper.getParam('id')),
                    "award_id": parseInt(obj.awardId),
                    "desc": obj.description
                }, function(data){
                    _.isFunction(callback) && callback(data);
                }, function(data){
                    _.isFunction(errCallback) && errCallback(data);
                }, true);
            },

            item: function(obj, callback, errCallback)
            {
                Sandbox.transport.send(Config.transport.channels.awardItem, {
                    "board_id": this.model.get('forum').get('boardId'),
                    "user_id": this.model.get('users').getMe().get('id'),
                    "award": {
                        "id": obj.id || null,
                        "name": obj.name,
                        "desc": obj.desc,
                        "href": obj.href,
                        "width": 100,
                        "height": 100
                    }
                }, function(data){
                    _.isFunction(callback) && callback(data);
                }, function(data){
                    _.isFunction(errCallback) && errCallback(data);
                }, true);
            },

            deleteItem: function(obj, callback, errCallback)
            {
                Sandbox.transport.send(Config.transport.channels.awardRemoveItem, {
                    "board_id": this.model.get('forum').get('boardId'),
                    "user_id": this.model.get('users').getMe().get('id'),
                    "id": obj.id
                }, function(data){
                    _.isFunction(callback) && callback(data);
                }, function(data){
                    _.isFunction(errCallback) && errCallback(data);
                }, true);
            },

            editDescription: function(obj, callback, errCallback)
            {
                Sandbox.transport.send(Config.transport.channels.editSentAward, {
                    "board_id": this.model.get('forum').get('boardId'),
                    "user_id": this.model.get('users').getMe().get('id'),
                    "award": {
                        "id": obj.id,
                        "desc": obj.description
                    }
                }, function(data){
                    _.isFunction(callback) && callback(data);
                }, function(data){
                    _.isFunction(errCallback) && errCallback(data);
                }, true);
            },

            saveSettings: function(obj, callback, errCallback)
            {
                Sandbox.transport.send(Config.transport.channels.collector, {
                    "board_id": this.model.get('forum').get('boardId'),
                    "user_id": this.model.get('users').getMe().get('id'),
                    "board": obj
                }, function(data){
                    _.isFunction(callback) && callback(data);
                }, function(data){
                    _.isFunction(errCallback) && errCallback(data);
                }, true);
            }

        });

        return {
            initialize: function(model)
            {
                return new AwardsModel({
                    model: model
                })
            }
        }
    }
);

